import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent {
  @Input() isMobileBreakpoint = false;

  constructor() {}
}
